React = require 'react'
Auth = require 'db/auth'
Controller = require 'controller'
t = require('views/internal/recup-with-helpers')()
HomeFeedbackLink = require 'views/home/home-feedback-link'
HomeLeftSidebarContainer = require 'views/home/home-left-sidebar-container'
HomeMainContentContainer = require 'views/home/home-main-content-container'
HomeRightSidebarContainer = require 'views/home/home-right-sidebar-container'

module.exports = class HomeContainer extends React.Component
  displayName: 'HomeContainer'

  componentWillReceiveProps: (nextProps) ->
    { modelCache, orgname } = nextProps

    if orgname
      orgs = modelCache.get('Member', Auth.myId())?.getSortedOrgs()
      if (!orgs.find((org) => org.get('name') == orgname))
        Controller.navigate('/', { trigger: true })

  render: t.renderable ->
    { modelCache, model, orgname } = @props

    t.div '.home-container', =>
      t.createElement HomeFeedbackLink, {
        memberId: Auth.me().id
      }
      t.createElement HomeLeftSidebarContainer, {
        modelCache
        model
        orgname
      }
      t.createElement HomeMainContentContainer, {
        modelCache
        orgname
      }
      t.createElement HomeRightSidebarContainer, {
        modelCache
        model
        orgname
      }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-container.coffee